import {Routes} from '@angular/router';
import {Login} from './login/login';
import {Home} from './home/home';
import { loggedIn } from '@angular/fire/auth-guard';

export const routes: Routes = [
  {path: 'login', component: Login},
  {path: '', component: Home, canActivate: [loggedIn]},
  {path: '**', redirectTo: ''}
];
